/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Grid_Remove_ItemInputs */

const cs_builder_grid_remove_item = /** @type {(inputs: Builder_Grid_Remove_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odebrat`)
};

const en_builder_grid_remove_item = /** @type {(inputs: Builder_Grid_Remove_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Builder_Grid_Remove_ItemInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_grid_remove_item = /** @type {((inputs?: Builder_Grid_Remove_ItemInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Grid_Remove_ItemInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_grid_remove_item(inputs)
	return cs_builder_grid_remove_item(inputs)
});